<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    size="xl"
    title="Dane kontrahenta"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <payment-data-form :schema="$schema.data.bankAccountOwner" />
  </w-modal>
</template>

<script>
import PaymentDataForm from '@/components/forms/PaymentDataForm.vue';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/paymentData.schema';

// @vuese
// Modal zarządzania danymi kontrahenta
// @group Payment
export default {
  components: { PaymentDataForm },
  mixins: [manageMixin('paymentData', {})],
  props: {
    // Dane z dokumentu
    data: { type: Object, required: false }
  },
  schema,
  data() {
    return { model: {} };
  },

  methods: {
    // Ustawia przekazane dane w formularzu
    setData() {
      this.$schema.$setDefault();

      const documentData = this.data.data;
      const bankAccountOwner = documentData.bankAccountOwner;

      this.$schema.$setData({
        ...this.data,
        data: {
          ...documentData,
          bankAccountOwner: {
            ...bankAccountOwner,
            hasPesel: bankAccountOwner.hasPesel !== undefined ? bankAccountOwner.hasPesel : !!bankAccountOwner.pesel
          }
        },
        id: this.data?.documentId
      });
      this.$schema.$reset();
    }
  }
};
</script>
